export const isServer: boolean = typeof window === 'undefined' || (window as any).isServer === true

/**
 * This function is used to notify the client that the application is ready.
 * @see apps/memory-of-souls/web/src/index.html
 */
export function markApplicationAsReady() {
	// eslint-disable-next-line
	if (typeof window !== 'undefined' && typeof (window as any)._applicationReady === 'function') {
		// eslint-disable-next-line
		;(window as any)._applicationReady()
		// eslint-disable-next-line
		;(window as any)._applicationReady = undefined
	}
}

/**
 * This function is used to prevent the prerendering of the application.
 * @param prevent
 */
export function preventPrerendering(prevent = true) {
	if (typeof localStorage === 'undefined') {
		return
	}

	localStorage.setItem('no-prerendering', prevent ? 'true' : 'false')
}
